import cn from 'classnames'
import styled from 'styled-components'
import tw from 'twin.macro'

export const StyledHint = styled.div`
  ${tw`mt-1 text-xs flex font-normal leading-4 tracking-normal text-left flex-grow-0 not-italic`};
  ${(props) => (props.errorText ? tw`text-lipstick ` : tw`text-blueGreyThree`)}
`
